// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sZZO","delete":"styles_delete__1i0dG","update":"styles_update__1JXhY","add":"styles_add__6TH8G"};